
const isParamPresent = ([key, value]) => key && value;

const getSearchParams = url => url.split('?')
  .pop()
  .split('&')
  .map(pair => pair.split('='))
  .filter(isParamPresent);

const getParamsFromUrl = () => {
  const arrayWithParams = getSearchParams(window.location.search);
  window.history.replaceState(null, '', `${window.location.origin}${window.location.pathname}`);
  let params = {};
  arrayWithParams.forEach(param => {
    params[param[0]] = param[1];
  });
  return params;
}

export default getParamsFromUrl;
